<div class="container-fluid">
  <!--<div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>-->

  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-chart-line mr-2"></i>{{ menu.accountAnalyticsI18n }}
  </h1>

  <!-- Description -->
  <p class="lead">The Account Analytics module provides visual representations of your income and expenses, allowing you to easily track and analyze your financial data.</p>

  <!-- DataTales Example -->
  <div class="card shadow mb-4">
    <div class="card-body">
      <ngx-charts-bar-vertical
        [view]="view"
        [scheme]="'cool'"
        [results]="incomes"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
      ></ngx-charts-bar-vertical>

      <ngx-charts-bar-vertical
        [view]="view"
        [scheme]="'cool'"
        [results]="expenses"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel1"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
      ></ngx-charts-bar-vertical>
    </div>
  </div>
</div>

